<div class="modal-body width-800">
  <div class="layout-auto-1-auto">
    <h5 class="modal-header">{{ title }}</h5>

    <div class="content">
      <div style="display: flex; margin-bottom: 1rem;">
        <div [style.fontWeight]="currentStep === 'vn'"
             [style.color]="signatureVN ? 'var(--c-green-400)' : 'inherit'">
          {{ labelVN }}
          <i *ngIf="signatureVN" class="fal fa-check" style="color: var(--c-green-400);"></i>
        </div>
        <div style="margin: 0 1rem;">--></div>
        <div [style.fontWeight]="currentStep === 'entgegen'"
             [style.color]="signatureEntgegen ? 'var(--c-green-400)' : 'inherit'">
          {{ labelEntgegen }}
          <i *ngIf="signatureEntgegen" class="fal fa-check" style="color: var(--c-green-400);"></i>
        </div>
      </div>

      <div style="margin-bottom: 0.5rem; font-weight: 500;">
        {{ currentStep === 'vn' ? 'Unterschrift ' + labelVN : 'Unterschrift ' + labelEntgegen }}
      </div>

      <div class="signature-field-container">
        <div class="signature-container finish-event-signature-container">
          <div style="background: white;">
            <app-exg-signature
              (onStrokeEnd)="handleHasImage1()"
              #sigPad1
              [bg]="'rgba(0,0,0,0)'"
              [h]="400"
              [minWidth]="6"
              [maxWidth]="10.5">
            </app-exg-signature>
          </div>
          <div class="signature-caption">
            {{ currentStep === 'vn' ? labelVN : captionEntgegen }} (*)
          </div>
          <div class="undo-button-container">
            <i class="fas fa-undo finish-event-undo" (click)="deleteImage1()"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="spawn-modal-actions">
      <button class="md-btn" (click)="close()">{{getGlobal('Cancel')}}</button>

      <button *ngIf="currentStep === 'vn'"
              class="md-btn md-btn-primary"
              [disabled]="!signatureVN"
              (click)="saveAndContinue()">
        Speichern und Weiter
      </button>

      <button *ngIf="currentStep === 'entgegen'"
              class="md-btn md-btn-primary"
              [disabled]="!signatureEntgegen"
              (click)="saveAndGeneratePDF()">
        Speichern und PDF Generieren
      </button>
    </div>
  </div>
</div>
